import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, getIn } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import Typography from '@mui/material/Typography';
import moment from "moment";
import CustomSelect from "../CustomComponents/CustomSelect";
import { dateTransformation } from '../../utils.js'
import InvoiceBreakdown from '../Table/InvoiceBreakdown'
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
// import InvoiceCalculate from '../Table/InvoiceCalculate';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import {logger,checkAuthentication} from '../../utils';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';

export default function EditInvoiceDialog({ handleEditCallback,handleRefreshCallback, data, invoices }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [displayExpense, setDisplayExpense] = React.useState(false);
    const [unassignedExpenses, setUnassignedExpensesDataset] = React.useState([]);
    const [assignedExpenses, setAssignedExpensesDataset] = React.useState([]);
    const [assignedTotal, setAssignedTotal] = React.useState([]);
    const currencyRegEx = /^(?!0\.00)\d{1,3}(,\d{3})*(\.\d\d)?$/;    
   logger(`editinvoice Data`, data)
    const [isLoading, setIsLoading] = React.useState(true);
    const [loadData, setLoadData] = React.useState();
    const [string, setString] = React.useState({InvoiceID:0});
    const [poChoices, setPoChoices] = React.useState([]);
    const [calculateTotals, setCalculateTotals] = React.useState([]);
    const [Discount, setDiscount] = React.useState([]);
    const [allInvoices, setAllInvoices] = React.useState([]);
    const startDate = moment.utc(data.StartDate).format("YYYY-MM-DD");
	const endDate = moment.utc(data.EndDate).format("YYYY-MM-DD");
    const [LockedAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState([]);
    const [POIDLocal, setPOIDLocal] = React.useState(data.POID);
    const [ot, setOT] = React.useState([]);
    const [expenses, setExpense] = React.useState([]);
 //   const [calcTime, setCalcTime] = React.useState([]);
 //   const [calcExpenses, setCalcExpenses] = React.useState([]);
   // const [calcOvertime, setCalcOvertime] = React.useState([]);
    const timer = React.useRef(null); 
    const calcTime = [];
    const calcExpenses = [];
    const calcOvertime = [];
    var rawTotal;
    var expensesTotal;
    var mergeTotals = [];
    //var grandTotal;
    var tmpTotal;

    const initialValues = {
        name: 'initial',
        id:  data.ID,
        POID: data.POID,
        invoice: data.InvoiceNumber,
        start: moment.utc(data.StartDate).format("MM/DD/YYYY"),
        end: moment.utc(data.EndDate).format("MM/DD/YYYY"),
		InvoiceDate: data.InvoiceDate != null && data.InvoiceDate != "" ? moment.utc(data.InvoiceDate).format("MM/DD/YYYY") : "",
        amount: parseFloat(data.Amount).toFixed(2),
        IsVoid: data.isVoid ? true : false,
        IsBilled: data.IsBilled ? true : false,
        Expense: ""
    };
    
    const validFormSchema = Yup.object({
        POID: Yup
            .string('Enter a PO to attach this invoice to ')
            .required('Linked PO is required'),
        invoice: Yup
            .string('Enter a name for the invoice')
            .required('Name is required'),
        start: Yup
            .date('Enter a start date "MM/DD/YYYY"')
            .required('Start date is required "MM/DD/YYYY"'),
        end: Yup
            .date('Enter a end date "MM/DD/YYYY"')
            .required('End date is required "MM/DD/YYYY"'),
        InvoiceDate: Yup
            .date('Enter a end date "MM/DD/YYYY"'),
        amount: Yup.number().test(
            'is-Currency',
            'invalid Currency',
            value => (value.toFixed(2)+"").match(/^[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)$/),
        ),
        IsVoid: Yup
            .boolean(),
    })

    const onTrigger = React.useCallback((values) => {
        var poStartDate = moment.utc(poChoices.filter(x => x.value == values.POID)[0].StartDate)
        var poEndDate = moment.utc(poChoices.filter(x => x.value == values.POID)[0].EndDate)
		var tempAlert = [];
        const msg = {
            ID: data.ID,
            POID: values.POID,
            InvoiceNumber: values.invoice,
            StartDate: moment.utc(values.start),
            EndDate: moment.utc(values.end),
            InvoiceDate: moment.utc(values.InvoiceDate),
            Amount: parseFloat(values.amount).toFixed(2),
            IsVoid: values.IsVoid ? 1 : 0,
            ExpenseID: values.Expense,
            UpdatePO: !poChoices.filter(choice => choice.value == values.POID)[0] ? true :false
        };

        if ((!moment.utc(values.start).isSame(poStartDate) && !moment.utc(values.start).isBetween(poStartDate, poEndDate))
            || (!moment.utc(values.end).isSame(poEndDate) && !moment.utc(values.end).isBetween(poStartDate, poEndDate))
        ) {
            tempAlert.push(`outside PO dates (PO:${poChoices.filter(x => x.value == values.POID)[0].label} Start:${moment.utc(poStartDate).format("YYYY-MM-DD")} End:${moment.utc(poEndDate).format("YYYY-MM-DD")})`);
            setAlertText(tempAlert);
            setAlert(true);
            return;
        }

        if( ( moment.utc(values.start)>moment.utc(values.end))){
            tempAlert.push("EndDate cannot be earlier than StartDate, Please enter different time period");
			setAlertText(tempAlert);
			setAlert(true);
			return;
		} 
		for (var i = 0; i < invoices.length; i++) {
			var eachInvoice = invoices[i];
			if (eachInvoice.ID!==data.ID && eachInvoice.POID === values.POID && (moment(values.start).isBetween(eachInvoice.StartDate, eachInvoice.EndDate)
				|| moment(values.end).isBetween(eachInvoice.StartDate, eachInvoice.EndDate)
				|| moment(eachInvoice.StartDate).isBetween(values.start, values.end)
				|| moment(eachInvoice.EndDate).isBetween(values.start, values.end)
				|| moment(eachInvoice.StartDate).isSame(values.start)
				|| moment(eachInvoice.EndDate).isSame(values.end)
				|| moment(eachInvoice.StartDate).isSame(values.end)
				|| moment(eachInvoice.EndDate).isSame(values.start))) {
				tempAlert.push(
					`Invoice (PO: ${poChoices.filter(x => x.value == values.POID)[0].label}) is already available with overlapping dates.
   Existing Invoice Period: ${moment(eachInvoice.StartDate).format("YYYY-MM-DD")} to ${moment(eachInvoice.EndDate).format("YYYY-MM-DD")}.
   Requested Period: ${moment(values.start).format("YYYY-MM-DD")} to ${moment(values.end).format("YYYY-MM-DD")}.
   Please check the request.`);
				setAlertText(tempAlert);
				setAlert(true);
				return;
			}
		}
		
		
		handleEditCallback(msg);        
        handleClose2();
		
    })
    const handleClose = React.useCallback(() => {
        setCalculateTotals([]);
        handleRefreshCallback();        
        setOpen(false);
        setDisplayExpense(false);
        setIsLoading(true);
        setRefresh(true);
    })

	const handleAlertClose = () => {
	        setAlert(false);
	    };
	    
    const handleClickOpen = () => {
        setOpen(true)
        setRefresh(true)
        setPOIDLocal(data.POID);
        logger("POIDLocal-Handleclickopen", POIDLocal)
        //logger(data)
     //   setLoadData(true)
      timer.current = setTimeout(() => {
        setLoadData(true)
        setRefresh(true)

      }, 2000);
   
 
    };

    const handleClose2 = () => {
       	setIsLoading(true);
        setOpen(false);
        setDisplayExpense(false);
        setCalculateTotals([]);
        //setRefresh(true);
    };

    const handleCalculate = (data) => {
     //   timer = setTimeout(() => {
      //     setLoadData(true)
           setRefresh(true)
        
     //   }, 1000);
    };

    const getTime = async () => {
        logger(`GetTime:${POIDLocal}/:${data.ID}/:${data.IsBilled}/:${data.StartDate}/:${data.EndDate}`)

        const response = await fetch(`api/InvoiceSum/${POIDLocal}/${data.ID}/${data.IsBilled}/${startDate}/${endDate}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                return (json)
            });
        setAllInvoices(response);
        return response;
    }

    const getExpenses = async () => {
        const response = await fetch(`/api/assignedExpenses?invoiceID=` + data.ID, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                return (json)
            });
        setExpense(response);
        return response;
    }

    const getOT = async () => {
         const response = await fetch(`/api/invoice/OverTime/${data.POID}`, {
                method: 'Get',
            })
                .then(res => res.json())
             .then(json => {
                    return(json)
                })
            setOT(response);
            return response;
    }

    //why is this never called?
    //const processOvertime = (calcOvertime) => {
    //    return (calcOvertime);
   // }

 const grandTotal = (Labor, Expense) => {
	    let res;
	    const discountedLabor = applyDiscountForEachItem();
        if (Expense>0) {
            let tmpTotal = parseFloat(discountedLabor) + parseFloat(Expense)
            let res = parseFloat(tmpTotal).toFixed(2)
            //logger(`GT with Exp`, res)
            return res;
        } else {
            let res = parseFloat(discountedLabor).toFixed(2)
            //logger(`GT no Exp`, res)
            return res;
        }
       //  return res;
    }
    



    //Paul Owens
    const applyDiscount = (price) => {
        var getPrice = Discount.Discount / 100;

        var totalValue = price - (price * getPrice)
        //logger("TotalValue" , parseFloat(totalValue).toFixed(2));
        return parseFloat(totalValue).toFixed(2);
    }
   
    const applyDiscountForEachItem = () => {
		var totalValue = 0;
		allInvoices.forEach((timeEntry, index) => {
			var price = getItemPrice(timeEntry);
			var dayOf = timeEntry.DayOf;
			var disc = 0;
			Discount.forEach((discount, index1) => {
				var start = discount.StartDate;
				var end = discount.EndDate;
				if (moment.utc(dayOf) >= moment.utc(start) && moment.utc(dayOf) <= moment.utc(end)) {
					disc = discount.Discount / 100;
					logger("disc", disc)
				}
			});
			
			totalValue += price - (price * disc);
		})
        
        logger(totalValue.toFixed(2));
        return totalValue.toFixed(2);
    }
    
    const getItemPrice = (item) => {
		const byteArray = new Uint8Array(item.Rate.data);
		const textDecoder = new TextDecoder();
		const res = textDecoder.decode(byteArray);
		const r = parseFloat(res).toFixed(2);
        return calculateRate1(r, item.FlagType) * item.Hours;
        //return calculateRate(r, item.FlagType, calcOvertime) * item.Hours;
    };
	
	var calculateRate1 = (rate, flagType) => {
		if (flagType === 'OT') {
			return (rate * ot[0].OverTimeWeek).toFixed(2);
		} else if (flagType === 'WND') {
			return (rate * ot[0].OverTimeWeekEnd).toFixed(2);
		} else if (flagType === 'HOL') {
			return (rate * ot[0].OverTimeHoliday).toFixed(2);
		} else {
			return rate;
		}
	};

    var calculateRate = (rate, flagType,calcOvertime) => {
		logger('flagType',flagType, 'Rate' , rate )
		logger( 'calcOvertime', calcOvertime )
	        if (flagType === 'OT') {
	            return rate * calcOvertime[0].OverTimeWeek;
	        } else if (flagType === 'WND') {
	            return rate * calcOvertime[0].OverTimeWeekEnd;
	        } else if (flagType === 'HOL') {
	            return rate * calcOvertime[0].OverTimeHoliday;
	        }else {
				return rate;
			} 
    };

    //why is calcOvertime never used
    const processTime = (calcTime, calcOvertime) => {  
         rawTotal = 0
        calcTime.map((item, index) => {
			const byteArray = new Uint8Array(item.Rate.data);
			const textDecoder = new TextDecoder();
			const res = textDecoder.decode(byteArray);
			const r = parseFloat(res).toFixed(2);
			let temp = calculateRate(r, item.FlagType , calcOvertime);
			logger ('Temp data', temp)
            rawTotal += temp * item.Hours
			//logger('Rawtotal',rawTotal ,'item.Rate', item.Rate,'item.Hours', item.Hours ,'item.FlagType', item.FlagType)
        })
        if (calculateTotals) { mergeTotals = [...calculateTotals] }

        var tmp = [{
            TimeTotal: rawTotal,
            ExpenseTotal: expensesTotal
        }]
        mergeTotals.push(tmp)
        setCalculateTotals (mergeTotals);                  
    }
    const processExpenses = (calcExpenses) => {
         expensesTotal = 0
        calcExpenses.map((bill, index) => {
            expensesTotal += (bill.Amount)
        })
        if (calculateTotals) { mergeTotals = [...calculateTotals] }
        var tmp = [{
            TimeTotal: rawTotal,
            ExpenseTotal: expensesTotal }]
        mergeTotals.push(tmp)
        setCalculateTotals(mergeTotals); 
        if (calculateTotals.length > 0) {
            setRefresh(true)
            setIsLoading(false)
        } else {
              timer.current = setTimeout(() => {
          //       setLoadData(true)
            setRefresh(true)
              }, 2000);
           
        }
    }

    const checkTotals = () => {
        if (calculateTotals.length > 0) {
            setIsLoading(false)
        }

    }

	const setExpenses = (json) => {
		let unassignedChoices = [];
		json.forEach(choice => {
			if (choice.InvoiceID == 0) {
				unassignedChoices.push({ label: choice.Name, value: choice.ID })
			}
		})
		setUnassignedExpensesDataset(unassignedChoices);
	}

    const setChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({
			label: choice.CommonName + " (" + moment.utc(choice.StartDate).format("YYYY-MM-DD") + " - " + moment.utc(choice.EndDate).format("YYYY-MM-DD") + ")",
			value: choice.ID,
			StartDate: choice.StartDate,
			EndDate: choice.EndDate
		}))
        setPoChoices(choices)
    }

	 const setExpenses1 = (json) => {
        let assignedChoices = [];
        json.forEach(choice => assignedChoices.push({ label: choice.Name, value: choice.ID }))
        setAssignedExpensesDataset(assignedChoices)
    }
    const handleBreakdownCallback = () => {
        setRefresh(true);
    };
    React.useEffect(() => {
		if(open){
		checkAuthentication();
		}
        if (refresh) {
            if (data.IsBilled == 1) {
                fetch(`/api/DiscountID/${data.DiscountID}`, {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => setDiscount(json));
            } else {
                fetch(`/api/Discount_Active/${moment.utc(data.StartDate).format("YYYY-MM-DD")}/${moment.utc(data.EndDate).format("yyyy-MM-DD")}`, {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => setDiscount(json));
            }

			fetch(`api/PO/dropdown?IsBilled=${data.IsBilled ? 1 : 0}`, {
				method: 'GET',
			})
				.then(res => res.json())
				.then(json => setChoices(json));
                fetch('/api/assignedExpenses?invoiceID=' + data.ID, {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => setExpenses1(json))
            //    .then(json => setCalcExpenses(json))
            //    .then(json => processExpenses(json, calcExpenses)) 

                fetch('/api/expenses', {
                    method: 'Get',
                })
                    .then(res => res.json())
                .then(json => setExpenses(json));

            checkTotals();

           /* if (calculateTotals.length >0) {
 //               logger(`InRefresh-totals`, calculateTotals)
//                logger(`line296CTotal -true`, calculateTotals)
                setIsLoading(false)

            }*/
                /*CalculatedTotal(data)*/    

         setRefresh(false);
         
        }
        if (loadData) {

            getOT(data)
                .then(responseOT => {
                    getTime(data)
                        .then(responseTIME => processTime(responseTIME, responseOT)) 
                })

            getExpenses(data)
                .then(response => processExpenses(response))





 setLoadData(false)
        }

       
    })
    
    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Tooltip title="Edit" placement="top-end">
            <IconButton variant="contained" onClick={handleClickOpen}>
                <BorderColorRoundedIcon color="primary" />
                </IconButton>             
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>
                   
                    <Formik
                        initialValues={initialValues}

                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div" >
                                            Edit Invoice
                                        </Typography>
                                        <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Invoice Info:      
                                    <FormControl sx={{ m: 1 }}>
													{ !poChoices.filter(choice => choice.value == props.values.POID)[0] && 
														<Alert icon={<CheckIcon fontSize="inherit" />} severity="error">
															PO is Expired for the Invoice, Please select the new Active PO .
														</Alert>
													}
												</FormControl></DialogTitle>
                                <Grid container spacing={1} pt={1} pl={1}>
                                    <Grid container spacing={1} xs={8}>
                                        <Grid item xs={12}>
                                  <div>

                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-Name">PO Name</InputLabel>
                                        <CustomSelect
                                            name='POID'
                                            id="outlined-costCenter"
                                            options={poChoices}
                                            onChange={(event) => {
											    logger('POID changed:', event.target.value);
											    props.handleChange(event);
											    setPOIDLocal(event.target.value);
											    setLoadData(true);
											    setIsLoading(true);
											    setCalculateTotals([]);
											}}
                                            disabled={data.IsBilled}
                                            onBlur={props.handleBlur}
                                            value={props.values.POID}
                                            error={props.touched.POID && Boolean(props.errors.POID)}
                                            helperText={props.touched.POID && props.errors.POID}
                                            label='POID'
                                        />
                                    </FormControl>

                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <TextField
                                            name='invoice'
                                            id="outlined-Location"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            disabled={data.IsBilled==0}
                                            value={props.values.invoice}
                                            error={props.touched.invoice && Boolean(props.errors.invoice)}
                                            helperText={props.touched.invoice && props.errors.invoice}
                                            label="Invoice Number"
                                        />
                                    </FormControl>
                                    {displayExpense && <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-Invoice">Expense</InputLabel>
                                        <CustomSelect
                                            name='Expense'
                                            id="outlined-Expense"
                                            options={unassignedExpenses}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Expense}
                                            error={props.touched.Expense && Boolean(props.errors.Expense)}
                                            helperText={props.touched.Expense && props.errors.Expense}
                                            label="Expense"
                                        />
                                    </FormControl>
                                    }

                                    {!displayExpense && <FormControl sx={{ m: 1, width: 220 }}>
                                                    <Button disabled={data.IsBilled} variant="contained" onClick={() => setDisplayExpense(true)}>
                                            Add Expense
                                        </Button>
                                                </FormControl>}
                                  </div>
                                   </Grid>
                                        <Grid item xs={12}>
                                            <div>
                                                {(assignedTotal.length) > 0 ? <FormControl sx={{ m: 1, width: 220 }}>
                                                    <List
                                                        sx={{
                                                            width: '100%',
                                                            maxWidth: 360,
                                                            bgcolor: 'background.paper',
                                                            position: 'relative',
                                                            overflow: 'auto',
                                                            maxHeight: 300,
                                                            border: '1px solid rgba(0, 0, 0, 0.1)',
                                                            '& ul': { padding: 0 },
                                                        }}
                                                        subheader={<ListSubheader >{`Attached Expenses`}</ListSubheader>}
                                                    >

                                                        <Divider />
                                                        <li>
                                                            <ul>
                                                                {assignedTotal.map((p, index) => (
                                                                    <ListItem key={p.value}>
                                                                        <ListItemText primary={p.label} />
                                                                    </ListItem>
                                                                ))}
                                                            </ul>
                                                        </li>
                                                    </List>
                                                </FormControl> : null}
                                            </div>
                                            <div>
                                                <FormControl sx={{ m: 1, width: 220 }}>
                                                    <TextField
                                                        name='start'
                                                        id="outlined-StartDate"
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        disabled={data.IsBilled}
                                                        type="date"
                                                        value={props.values.start.indexOf("/") > 0 ? dateTransformation(props.values.start) : props.values.start}
                                                        error={props.touched.start && Boolean(props.errors.start)}
                                                        helperText={props.touched.start && props.errors.start}
                                                        label="Start Date"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </FormControl>

                                                <FormControl sx={{ m: 1, width: 220 }}>
                                                    <TextField
                                                        name='end'
                                                        id="outlined-EndDate"
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        disabled={data.IsBilled}
                                                        type="date"
                                                        value={props.values.end.indexOf("/") > 0 ? dateTransformation(props.values.end) : props.values.end}
                                                        error={props.touched.end && Boolean(props.errors.end)}
                                                        helperText={props.touched.end && props.errors.end}
                                                        label="End Date"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </FormControl>
                                                <FormControl sx={{ m: 1, width: 220 }}>
                                                    <TextField
                                                        name='amount'
                                                        id="outlined-Amount"
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        value={props.values.amount}
                                                        error={props.touched.amount && Boolean(props.errors.amount)}
                                                        helperText={props.touched.amount && props.errors.amount}
                                                        label="Amount"
                                                    />
                                                </FormControl>
                                            </div>
                                            <div>
                                                <FormControl sx={{ m: 1, width: 220 }}>
													<TextField
														name='InvoiceDate'
														id="outlined-InvoiceDate"
														type="date"
														onChange={props.handleChange}
														onBlur={props.handleBlur}
														disabled={data.IsBilled == 0}
														value={props.values.InvoiceDate != null && props.values.InvoiceDate != "" && props.values.InvoiceDate.indexOf("/") > 0 ? dateTransformation(props.values.InvoiceDate) : props.values.InvoiceDate}
														error={props.touched.InvoiceDate && Boolean(props.errors.InvoiceDate)}
														helperText={props.touched.InvoiceDate && props.errors.InvoiceDate}
														label="Invoice Date"
														InputLabelProps={{
															shrink: true,
														}}
													/>
												</FormControl>
                                            </div>
                                            <div>
                                                {assignedExpenses.length > 0 && <FormControl sx={{ m: 1, width: 220 }}>
                                                    <List
                                                        sx={{
                                                            width: '100%',
                                                            maxWidth: 360,
                                                            bgcolor: 'background.paper',
                                                            position: 'relative',
                                                            overflow: 'auto',
                                                            maxHeight: 300,
                                                            border: '1px solid rgba(0, 0, 0, 0.1)',
                                                            '& ul': { padding: 0 },
                                                        }}
                                                        subheader={<ListSubheader >{`Assigned Expenses`}</ListSubheader>}
                                                    >
                                                        <Divider />
                                                        <li>
                                                            <ul>
                                                                {assignedExpenses.map((p, index) => (																	
                                                                   <ListItem key={p.value}>
																	    <ListItemText primary={p.label} />
																	    {data.IsBilled === 0 && (
																	        <IconButton
																	            edge="start"
																	            color="inherit"
																	            onClick={e => {
																	                fetch("api/expenses/remove", {
																	                    method: 'PATCH',
																	                    headers: { 'Content-Type': 'application/json' },
																	                    body: JSON.stringify({
																	                        "expenses": {
																	                            "InvoiceID": 0,
																	                            "ID": p.value,
																	                        }
																	                    })
																	                })
																	                .then(response => {
																	                    if (response.ok) {
																							setIsLoading(true);
																	                        setCalculateTotals([]);
																	                        setLoadData(true);
																	                        setRefresh(true);
																	                    } else {
																	                        setAlert(true);
																	                        setAlertText("Failed to remove expense.");
																	                    }
																	                })
																	                .catch(error => {
																	                    console.error('Error removing expense:', error);
																	                    setAlert(true);
																	                    setAlertText("An error occurred while removing expense.");
																	                });
																	            }}
																	            aria-label="close"
																	        >
																	            <CloseIcon />
																	        </IconButton>
																	    )}
																	</ListItem>
                                                                ))}
                                                            </ul>
                                                        </li>
                                                    </List>
                                                </FormControl>}
                                                <FormControl sx={{ m: 1 }}>
                                                    <FormControlLabel
                                                        name="IsVoid"
                                                        label="Void"
                                                        control={<Checkbox disabled={data.IsBilled} checked={props.values.IsVoid} onChange={props.handleChange} />}
                                                    />
                                                </FormControl>
												
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1} xs={4}>
                                        <Grid item xs={12}>
                                    {(isLoading) &&

                                        <FormControl sx={{ m: 1, height: 200, width: 300 }}>
                                            <InputLabel htmlFor="outlined-Name">Calculated Totals</InputLabel>
                                            <Box sx={{
                                                display: 'flex',
                                               minHeight: 200,
                                                width: '100%',
                                                borderColor: 'grey.500',
                                                m: 1,
                                                border: 1,
                                                borderRadius: 1,
                                                alignContent: 'center'
                                            }}>
                                                <Fade
                                                    in={(isLoading)}
                                                    style={{
                                                        transitionDelay: !isLoading ? '800ms' : '0ms',
                                                    }}
                                                    unmountOnExit
                                                >
                                                    <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                                        <CircularProgress color="secondary" />
                                                        <CircularProgress color="success" />
                                                        <CircularProgress color="inherit" />
                                                    </Stack>
                                                </Fade>
                                            </Box>
                                        </FormControl>
                                    }
                                    {(!isLoading) &&
                                      <FormControl sx={{ m: 1, width: 300 }}>
									   		
									        <Box>
									            <InputLabel htmlFor="outlined-Name" sx={{ marginTop: 'auto', marginBottom: 'auto'}}>Calculated Totals</InputLabel>
									        </Box>
									        <Box sx={{ marginLeft: 'auto' }}>
									            <InvoiceBreakdown
									                handleBreakdownCallback={handleBreakdownCallback}
									                data={{
									                    PO: poChoices.filter(choice => choice.value == props.values.POID)[0]?.label,
									                    POID: props.values.POID,
									                    ID: props.values.id,
									                    InvoiceNumber: props.values.invoice,
									                    StartDate: moment.utc(props.values.start).format("YYYY-MM-DD"),
									                    EndDate: moment.utc(props.values.end).format("YYYY-MM-DD"),
									                    Amount: parseFloat(props.values.amount).toFixed(2),
									                    IsVoid: props.values.IsVoid,
									                    IsBilled: props.values.IsBilled
									                }} 
									            />
									        </Box>
									    
									   		{Object.values(calculateTotals[0]).map(p => {
													 return (
                                                            <Box sx={{
                                                                display: 'flex',
                                                                minHeight: 200,
                                                                width: '100%',
                                                                borderColor: 'grey.500',
                                                                m: 1,
                                                                border: 1,
                                                                borderRadius: 1
                                                            }}>
                                                                <Grid container spacing={1} pt={5} pl={1}>
                                                            <Grid item xs={8}>
                                                                Labor Raw Total
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                $ {parseFloat(p.TimeTotal).toFixed(2)}
                                                            </Grid>
                                                            <Grid item xs={8}>
                                                                Labor Discounted Total
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                               $ {applyDiscountForEachItem()}
                                                            </Grid>
                                                            <Grid item xs={8}>
                                                                Expenses Total
                                                            </Grid>
                                                                    <Grid item xs={4}>
                                                                        {p.ExpenseTotal ? (
                                                                            <React.Fragment>
                                                                                ${p.ExpenseTotal}
                                                                            </React.Fragment>
                                                                        ) : (
                                                                            <React.Fragment>
                                                                                $0
                                                                            </React.Fragment>
                                                                        )}
                                                            </Grid>
                                                                    <Grid item sx={{ fontWeight: 'bold' }} xs={8}>
                                                                        Invoice Total:                                                           
                                                                    </Grid>
                                                                    <Grid item sx={{ fontWeight: 'bold' }} xs={4}>
                                                                        
                                                                                ${grandTotal(p.TimeTotal, p.ExpenseTotal)}                                                                       
                                                                    </Grid>
                                                        </Grid>
                                                    </Box>
                                                   ) })}                 
											</FormControl>
                                            }
                                        </Grid>
                                    </Grid>
                             </Grid>
                                                             


                            </Form>
                        )}
                    </Formik>
                </DialogContent>  
                 <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Invoice Creation Issue"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {alertText.map((a, index) => {
								return(<p key={index}>{a}</p>)
								})}
			            </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            setAlert(false);
                            setAlertText([]);
                        }} autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>                  
            </Dialog></MuiThemeProvider>
        </div>
    );
} 